import { ReactNode } from 'react';

export enum FrontendSettingsTab {
  GENERAL = 'GENERAL',
  MENU = 'MENU',
  LOGO = 'LOGO',
  SOCIAL = 'SOCIAL',
  LOCALIZATION = 'LOCALIZATION',
}

export enum GeneralSettingsTab {
  STORE = 'STORE',
  SMS = 'SMS',
  EMAIL = 'EMAIL',
  PARTNER = 'PARTNER',
  SHIPMENT = 'SHIPMENT',
  PAYMENT = 'PAYMENT',
  POINT_SYSTEM = 'POINT_SYSTEM',
  PRICING = 'PRICING',
  ANALYTICS = 'ANALYTICS',
  AI = 'AI',
}

export interface SettingsTabDef<TKind> {
  kind: TKind;
  name: string;
  path: string;
  element: ReactNode;
}
